import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PoHeaderSearchParams } from 'src/app/core/models/transport-operation/po-header-search-params';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PoServiceService {
  constructor(private http: HttpClient) {}

  searchPoHeader(searchParams: PoHeaderSearchParams): Observable<any> {
    const url = `${environment.logisticsApiUrl}/purchaseOrder/searchPoHeader`;
    return this.http.post(url, searchParams);
  }

  searchPoDetailByPoNo(poNo: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/purchaseOrder/searchPoDetailByPoNo/${poNo}`;
    return this.http.get(url);
  }

  searchPoByPoNo(poNo: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/purchaseOrder/searchPoByPoNo/${poNo}`;
    return this.http.get(url);
  }

  searchAsnNoByPoNo(poNo:string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/asn/searchAsnNoByPoNo/${poNo}`;
    return this.http.get(url);
  }

  searchDnNoByPoNo(poNo:string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/deliveryNote/searchDnNoByPoNo/${poNo}`;
    return this.http.get(url);
  }

  searchAsnByAsnNo(asnNo: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/asn/searchAsnByAsnNo/${asnNo}`;
    return this.http.get(url);
  }

  searchDnByDnNo(dnNo:string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/deliveryNote/searchDnByDnNo/${dnNo}`;
    return this.http.get(url);
  }

  createAd(createAdByPoReq : any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/purchaseOrder/addAdvisingByPurchaseOrder`;
    return this.http.post(url, createAdByPoReq);
  }

  getMappingFacilityOptions(): Observable<any>{
    const url = `${environment.logisticsApiUrl}/facility/getMappingFacilityOptions/Wistron`;
    return this.http.get(url);
  }

  getMappingDeclTypeOptions(): Observable<any>{
    const url = `${environment.logisticsApiUrl}/purchaseOrder/declTypeOptions`;
    return this.http.get(url);
  }

}
